import React from 'react';
import { String } from '@silvertours/front-shared';
import AirConditioning from '@engineering/icons/air-conditioning';
import Automatic from '@engineering/icons/automatic';
import CityStation from '@engineering/icons/city-station';
import Doors from '@engineering/icons/doors';
import Seats from '@engineering/icons/seats';
import TransmissionIcon from '@engineering/icons/transmission';
import { useLocale, useCarImage } from '../Runtime';

import {
  Container,
  ImageWrapper,
  Body,
  CarAttributes,
  CarAttribute,
  StyledIcon,
  Footer,
  CityWrapper,
  Headline,
  CarCategory,
  PriceWrapper,
  Price,
  PerDay,
  CallToAction,
  StyledArrowNext,
  Image,
} from './SerpOffer.styles';

type SerpOfferProps = {
  image: string;
  transmission: string;
  price: number;
  currency: string;
  carCategory: string;
  carName: string;
  seats: number;
  doors: string;
  airConditioning: boolean;
  city: string;
  onClick: () => void;
  translations: {
    airConditioning: string;
    transmissionManual: string;
    transmissionAutomatic: string;
    pricePrefix: string;
    priceSuffix: string;
  };
};

const SerpOffer = ({
  image,
  transmission,
  price,
  currency,
  carCategory,
  carName,
  seats,
  doors,
  airConditioning,
  city,
  onClick,
  translations,
}: SerpOfferProps) => {
  const { language } = useLocale();
  const [loading, setLoading] = React.useState(false);
  const imageUrl = useCarImage(image);

  const handleClick = () => {
    if (onClick && !loading) {
      setLoading(true);
      onClick();
    }
  };

  return (
    <Container onClick={handleClick} hasAction={!!onClick}>
      <Body>
        <Headline>
          <CarCategory>{carCategory}</CarCategory>
          <PriceWrapper>
            {translations.pricePrefix}
            <Price>{String.formatPrice(price, currency, language)}</Price>
            <PerDay>{translations.priceSuffix}</PerDay>
          </PriceWrapper>
        </Headline>
        <ImageWrapper>
          <Image src={imageUrl} alt="" fill />
        </ImageWrapper>
        <div>{carName}</div>
        <CarAttributes>
          <CarAttribute>
            <StyledIcon as={Seats} />
            <div>{seats}</div>
          </CarAttribute>
          <CarAttribute>
            <StyledIcon as={Doors} />
            <div>{doors}</div>
          </CarAttribute>
          <CarAttribute>
            {transmission === 'manual' ? (
              <>
                <StyledIcon as={TransmissionIcon} />
                <div>{translations.transmissionManual}</div>
              </>
            ) : (
              <>
                <StyledIcon as={Automatic} />
                <div>{translations.transmissionAutomatic}</div>
              </>
            )}
          </CarAttribute>
          {airConditioning && (
            <CarAttribute>
              <StyledIcon as={AirConditioning} />
              <div>{translations.airConditioning}</div>
            </CarAttribute>
          )}
        </CarAttributes>
      </Body>
      <Footer>
        <CityWrapper>
          <StyledIcon as={CityStation} />
          <div>{city}</div>
        </CityWrapper>
        <CallToAction loading={loading}>
          <StyledArrowNext />
        </CallToAction>
      </Footer>
    </Container>
  );
};

export { SerpOffer };
